import { Component, Input, OnInit } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { Subject, takeUntil } from 'rxjs';
import { FiremessagingService } from 'src/app/services/firebase-messaging/firemessaging.service';
import { AuthService } from 'src/app/_services/auth.service';
import { GetAllChatsModel } from '../../models/get-all-chats.model';
import { GetChatHistoryModel } from '../../models/get-chat-history.model';
import { ChatService } from '../../services/chat/chat-service';
import { ChatComponent } from '../chat/chat.component';

@Component({
  selector: 'app-chat-sidebar',
  templateUrl: './chat-sidebar.component.html',
  styleUrls: ['./chat-sidebar.component.scss']
})
export class ChatSidebarComponent implements OnInit {

  public unsubscribe: Subject<void> = new Subject<void>();
  public display: any;
  private userId: any;
  public chatList: Array<GetAllChatsModel>;
  public subscriberChatId: string;
  public newMessages: boolean = false;

  constructor(
    private authService: AuthService,
    public dialogService: DialogService,
    private chatService: ChatService,
    private firebaseService: FiremessagingService,
  ) {
    this.chatList = new Array<GetAllChatsModel>();
  }

  ngOnInit(): void {
    this.authService.user.subscribe((userData)=> {
      if(userData?.user?.id){
        this.userId = userData?.user?.id;
        // this.getAllChats(this.userId);
      }
    })    

    this.firebaseService.currentMessage.subscribe((msg: any) => {
      this.getAllChats(this.userId);
      this.newMessages = true;
      this.chatList.forEach(item => {
        if (item.id == msg.subscriberChatId) {
          item.messageRecieved = true;
          item.messages = item.messages.concat(msg);
          this.subscriberChatId = msg.subscriberChatId;
        }
      });
    })
  }

  getAllChats(id: string) {
    this.chatService.getallchats(id)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.chatList = response;
        }
      });
  };

  openChat(model: GetAllChatsModel) {
    const chatRequest = new GetChatHistoryModel();
    chatRequest.EventId = model.eventId;
    chatRequest.SubscriberId = model.subscriberId;
    chatRequest.SubscriberChatId = model.id;
    const subscriberFirstLast = model.subscriberUserFirstName + " " + model.subscriberUserLastName;
    const eventName = model.eventName;
    this.chatList.forEach(item => {
      if (item.id == model.id) {
        item.messageRecieved = false;
      }
      if (!item.messageRecieved) {
        this.newMessages = false;
      }
    });
    this.ChatDialog(chatRequest, subscriberFirstLast,eventName);
  }

  update() {
    this.getAllChats(this.userId);
  }

  ChatDialog(chatRequest: GetChatHistoryModel, subscriberFirstLast: string,eventName: string) {
    const ref = this.dialogService.open(ChatComponent, {
      data: {
        chatRequest: chatRequest
      },
      autoZIndex: true,
      header: subscriberFirstLast+" - "+eventName,
      width: '720px',
      // contentStyle: { "overflow-y": "auto" },
    });
    // this.loadingPage=true;
    ref.onClose.subscribe((messageSend: boolean) => {
      // this.loadingPage=false;
      if (messageSend) {
        this.getAllChats(this.userId);
      }
    });
  }


}